import React, { useContext } from "react";
import { Pressable, StyleSheet, useWindowDimensions, View } from "react-native";
import { NavigationContext } from "../../../providers";
import { getBreakpoint } from "../utils";
import { getCarouselHeight } from "../utils/getCarouselHeight";
import AlignedImage from "./AlignedImage";
import { CarouselOverlay } from "./CarouselOverlay";
export const AdvancedCarouselSlide = ({ slide, displayCarded = true, extendedImages = false, ...props }) => {
    const { onNavigateToItem } = useContext(NavigationContext);
    const { width: screenWidth, height: screenHeight } = useWindowDimensions();
    const breakpoint = getBreakpoint(screenWidth);
    const isMobile = breakpoint === "mobile";
    const imageSource = slide.mobileImage?.src && isMobile
        ? slide.mobileImage.src
        : slide.cover?.src;
    if (!slide.cover?.src)
        return null;
    const slideHeight = getCarouselHeight(screenWidth, screenHeight);
    const isCardMode = displayCarded && breakpoint !== "desktop";
    const isExtendedImagesMode = extendedImages && !isCardMode;
    const blackGradient = isMobile
        ? { start: { x: 0, y: 0 }, end: { x: 0, y: 1 } }
        : { start: { x: 1, y: 0 }, end: { x: 0, y: 0 } };
    return (React.createElement(Pressable, { onPress: () => onNavigateToItem(slide), style: {
            borderRadius: isCardMode ? 20 : 0,
            overflow: isExtendedImagesMode ? "visible" : "hidden",
            borderColor: isCardMode ? "#616161f1" : undefined,
            borderWidth: isCardMode ? 2 : undefined,
        } },
        React.createElement(View, { style: [staticStyles.imageBackground, { width: screenWidth }], ...props },
            React.createElement(AlignedImage, { uri: imageSource, width: screenWidth, height: slideHeight + (isExtendedImagesMode ? 120 : 0), bottomGradient: isExtendedImagesMode, blackGradient: blackGradient }),
            React.createElement(CarouselOverlay, { slide: slide, screenWidth: screenWidth, slideHeight: slideHeight }))));
};
const staticStyles = StyleSheet.create({
    imageBackground: {
        resizeMode: "cover",
    },
});
//# sourceMappingURL=AdvancedCarouselSlide.js.map